// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination--container--11hDt","pageControls":"Pagination--pageControls--2N6aK","divider":"Pagination--divider--35bDH"};